import * as React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

interface IProps {
    open: boolean;
    loading?: boolean;
    username?: string;
    onCancel: () => void;
    onSubmit: () => void;
}

const ApiAccessPasswordModal: React.FC<IProps> = ({
    open,
    loading,
    username,
    onCancel,
    onSubmit,
}) => (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
            centered
            width={680}
            closeIcon={<CloseOutlined className="text-gray-400" />}
            className="top-6"
            classNames={{
                content: '!rounded-2xl !p-0',
                header: '!hidden',
                body: '!p-0',
            }}
        >
            <div className="px-7 pb-6 pt-5">
                <div className="mb-1 text-xs uppercase tracking-[0.12em] text-gray-400">
                    API Access
                </div>
                <div className="mb-5 text-[22px] font-semibold text-gray-900">
                    Regenerate Password
                </div>
                <div className="rounded-2xl border border-gray-200 bg-[#fcfcfd] p-5 text-sm text-gray-600">
                    {username ? (
                        <div className="mb-3 font-medium text-gray-900">User: {username}</div>
                    ) : null}
                    A new password will be generated for this user. Make sure to copy it after it
                    is shown, because this is the only time it will be visible.
                </div>

                <div className="mt-5 flex flex-col-reverse justify-end gap-3 md:flex-row">
                    <Button shape="round" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        shape="round"
                        loading={loading}
                        onClick={onSubmit}
                        className="!border-0 !bg-[#df1f26] !shadow-none hover:!bg-[#c91b21] focus:!bg-[#c91b21]"
                    >
                        Regenerate Password
                    </Button>
                </div>
            </div>
        </Modal>
);

export default ApiAccessPasswordModal;
